import React, { useCallback, useEffect, useState } from 'react';

import Traductor from '../../../Traductor';

import FormHeader from '../../common/FormHeader';
import TextInput from '../../common/TextInput';
import RadioInput from '../../common/RadioInput';
import SelectInput from '../../common/SelectInput';
import DateInput from '../../common/DateInput';
import TicketingService from '../../../../services/TicketingService';
import Globals from '../../../../Globals';
import { withCookies } from 'react-cookie';

const CreateTicketDataForm = ({
    values,
    onChange,
    errors,
    touched,
    onTouch,
    cookies,
    userData,
}) => {
    const t = new Traductor();

    const [inputSelects, setInputSelects] = useState({
        selectConces: [],
        selectTypes: [],
    });

    const getAllSelects = () => {
        new TicketingService()
            .getSelects(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                userData.data.Empleado.Id
            )
            .then(response => {
                var newSelects = {
                    selectConces: response.body.SelectConces,
                    selectTypes: response.body.SelectTypes,
                };
                setInputSelects(newSelects);
            });
    };

    useEffect(() => {
        getAllSelects();
    }, [onChange]);

    const renderError = useCallback(
        name =>
            errors[name] &&
            touched[name] && (
                <p className="c-error-message">
                    *{t.getTraduction('RequiredFieldError')}
                </p>
            ),
        [errors, t, touched]
    );

    return (
        <section className="c-form-section  js-form-section  js-is-fx">
            <FormHeader text={t.getTraduction('TicketData')} expanded />
            <div
                className="c-form-section__panel  js-form-section__panel"
                aria-hidden="false"
            >
                <div className="c-form-section__content">
                    <div className="o-fieldset__row">
                        <div className="o-layout__item u-1/3 u-1/2@m">
                            {/* DATE*/}
                            <DateInput
                                label={t.getTraduction('TicketCreationDate')}
                                row
                                values={values}
                                name="ticketDate"
                                onChange={onChange}
                                readOnly
                            />
                        </div>
                        <div className="o-layout__item u-1/3 u-1/2@m">
                            {/*TICKET TYPE*/}
                            <SelectInput
                                options={inputSelects.selectTypes.map(
                                    (type, i) => {
                                        return {
                                            value: type.Value,
                                            label: type.Text,
                                        };
                                    }
                                )}
                                onChange={onChange}
                                label={t.getTraduction('TicketType')}
                                values={values}
                                name={'ticketType'}
                                row
                                touched={touched}
                                errors={errors}
                            />
                        </div>
                        <div className="o-layout__item u-1/3 u-1/2@m">
                            {/* CHANNEL CODE */}
                            <SelectInput
                                options={inputSelects.selectConces.map(
                                    (conces, i) => {
                                        return {
                                            value: conces.Value,
                                            label: conces.Text,
                                        };
                                    }
                                )}
                                onChange={onChange}
                                label={t.getTraduction('Concesionario')}
                                values={values}
                                name={'channelCode'}
                                row
                                touched={touched}
                                errors={errors}
                            />
                        </div>
                    </div>
                    {/* SHORT DESCRIPTION */}
                    <TextInput
                        label={t.getTraduction('DescShort')}
                        name="shortDescription"
                        values={values}
                        onChange={onChange}
                        errors={errors}
                        touched={touched}
                        buscador={false}
                    />
                    {/* LONG DESCRIPTION */}
                    <div className="c-accordion__header js-accordion__title c-vehicle-filters__item-title">
                        <span className="c-accordion__title"></span>
                        <h3 className="c-accordion__title">
                            <button
                                className="c-accordion__title-label js-accordion__title-label"
                                aria-expanded="true"
                                type="button"
                            >
                                <label
                                    htmlFor="longDescription"
                                    className="c-accordion__title-label-text "
                                >
                                    {t.getTraduction('DescLong')}
                                </label>
                            </button>
                        </h3>
                    </div>
                    <div className="c-form-field__box">
                        <div className="c-input  c-input--textarea">
                            <textarea
                                className="c-input__input  "
                                id="longDescription"
                                name="longDescription"
                                cols="30"
                                rows="10"
                                value={values.longDescription}
                                onChange={e =>
                                    onChange('longDescription', e.target.value)
                                }
                                onBlur={() => onTouch('longDescription')}
                            />
                        </div>
                        {renderError('longDescription')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CreateTicketDataForm;
